module.exports = __webpack_public_path__ + "img/tx.885e9f0b.png";